import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { AppBarLayout, Breadcrumbs } from 'commons-ui';

import AuthorizedRoute from '../../permission/AuthorizedRoute';
import { SETTINGS_V2_RESOURCES, PAGE_NAMES } from '../../settingsV2Constant';

import SettingsHome from './SettingsHome';
import { URL, COMPONENT } from './helper';

const Dashboard: React.FC<{}> = () => {
	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.settingsV2}
					path={`/${PAGE_NAMES.settingsV2}`}
					component={SettingsHome}
				/>
				{_map(_values(SETTINGS_V2_RESOURCES), (resourceName: string) => (
					<AuthorizedRoute
						key={resourceName}
						configPageName={PAGE_NAMES.settingsV2}
						configResourceName={resourceName}
						path={URL[resourceName]}
						component={COMPONENT[resourceName]}
					/>
				))}
				<Redirect to={`/${PAGE_NAMES.settingsV2}`} />
			</Switch>
		</>
	);
};

export default Dashboard;
